import * as types from "../service/types";

const InitState = {
  loading: false,
  listClientData: "",
  error: "",
};
const ListClientReducer = (state = InitState, action) => {
  switch (action.type) {
    case types.LIST_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.LIST_CLIENT_SUCCESS:
      return {
        loading: false,
        listClientData: action.payload,
        error: "",
      };
    case types.LIST_CLIENT_ERROR:
      return {
        loader: false,
        listClientData: "",
        error: action.error,
      };
    default:
      return state;
  }
};

export default ListClientReducer;